<template>
  <component :is="template" />
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import CabinetTemplate from '@/layouts/CabinetTemplate.vue';
import CabinetBlankTemplate from '@/layouts/CabinetBlankTemplate.vue';
import { AppModule } from '@/store/modules/app';
import { groupFullscreenCabinet } from '@/config/configuration';

// Вибір лояуту кабінету за сідом: звичайний (шапка + футер) або на всю сторінку.
@Component({
  components: {
    CabinetTemplate,
    CabinetBlankTemplate,
  },
})
export default class CabinetLayout extends Vue {
  get template() {
    return groupFullscreenCabinet(AppModule.sid) ? 'CabinetBlankTemplate' : 'CabinetTemplate';
  }
}
</script>
